/* eslint-disable prefer-destructuring */

export const colors = {
  white: '#FFFFFF',
  black: '#333',
  text: '#181D27',
  stroke: '#E9EAEB',
  textDisabled: '#BCC7D7',
  secondary: '#F7F8FA',
  textSecondary: '#64748B',
  strokeSecondary: '#DEDFF0',
  cardFillSecondary: '#F6F8FC',
  error: '#FE2400',
  danger: '#FEA201',
  primary: {
    light: '#D9E3FF',
    main: '#7B44F4',
    dark: '#7738ffff',
  },
  positive: {
    light: '#55AD53',
    main: '#2A9928',
    dark: '#268A24',
  },
  attentive: {
    light: '#FFCE53',
    main: '#FFC228',
    dark: '#E5AF24',
  },
  destructive: {
    light: '#FF5858',
    main: '#FF2E2E',
    dark: '#F22C2C',
  },
  greys: {
    100: '#F4F5F6',
    200: '#D3D5D9',
    300: '#A8ABB2',
    400: '#7D828D',
    light: '#515867',
    main: '#353C4D',
    dark: '#262E40',
  },
};

// Aliases
colors.disabled = colors.greys[300];
